import React from "react";
import { Tabs } from "antd";
import CustomersView from "../Customers/customersView";
import { useNavigate, useLocation } from "react-router-dom";

const NavigationCustomers = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const pathToKeyMap = {
    "/app/customers": "customers",
  };

  const keyToPathMap = {
    customers: "/app/customers",
  };

  const activeTab = pathToKeyMap[location.pathname] || "customers";

  const onChange = (key) => {
    navigate(keyToPathMap[key]);
  };

  const customTabBar = (props, DefaultTabBar) => (
    <div className="TabListTopBox">
      <DefaultTabBar {...props} />
    </div>
  );

  const items = [
    {
      key: "customers",
      label: "Customers",
      children: <CustomersView />,
    },
  ];

  return (
    <div className="TopTablesTabsBox TabNavigation">
      <Tabs
        activeKey={activeTab}
        onChange={onChange}
        renderTabBar={customTabBar}
        className="TopTablesTabs"
        items={items}
      />
    </div>
  );
};

export default NavigationCustomers;
